export class SavingAppInstallationIniError extends Error {}
